import { useQuery } from 'react-query';
import { queryCompanyConsultations } from './useCompanyConsultations.query';
import { PageQueryParams } from '../../../types/api/api.types';
import { UseCompanyConsultationsResponse } from './useCompanyConsultations.types';

export const ALL_COMPANY_CONSULTATIONS_QUERY_KEY = 'ALL_COMPANY_CONSULTATIONS';

export const useCompanyConsultations = (params: PageQueryParams) => {
  return useQuery<UseCompanyConsultationsResponse, Error>(
    ALL_COMPANY_CONSULTATIONS_QUERY_KEY,
    () => queryCompanyConsultations(params),
    {
      retry: false,
    }
  );
};
